import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './MapPicker.css';
import L from 'leaflet';

// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const parseLatLonFromUrl = (url) => {
    if (!url) return null;
    let match = url.match(/marker=([-0-9.]+),([-0-9.]+)/);
    if (match) return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
    match = url.match(/mlat=([-0-9.]+)&mlon=([-0-9.]+)/);
    if (match) return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
    return null;
};

function MapUpdater({ position }) {
    const map = useMap();
    useEffect(() => {
        if (position) {
            map.setView(position, 18);
        }
    }, [position, map]);
    return null;
}

function LocationMarker({ position, setPosition, onSelect }) {
    useMapEvents({
        click(e) {
            const { lat, lng } = e.latlng;
            setPosition(e.latlng);
            const bboxPadding = 0.001;
            const embedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${
                lng - bboxPadding
            },${lat - bboxPadding},${lng + bboxPadding},${lat + bboxPadding}
                &layer=mapnik&marker=${lat},${lng}`;

            onSelect(embedUrl);
        },
    });

    return position ? <Marker position={position} /> : null;
}

function MapPicker({ onLocationSelect, initialPositionUrl }) {
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (initialPositionUrl) {
            const parsed = parseLatLonFromUrl(initialPositionUrl);
            if (parsed) setPosition(parsed);
        }
    }, [initialPositionUrl]);

    return (
        <div className="map_picker_wrapper">
            <MapContainer
                center={position || [35.6892, 51.389]}
                zoom={position ? 18 : 13}
                className="map_container"
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                />
                <LocationMarker
                    position={position}
                    setPosition={setPosition}
                    onSelect={onLocationSelect}
                />
                <MapUpdater position={position} />
            </MapContainer>
        </div>
    );
}

export default MapPicker;
